import { init } from "@paralleldrive/cuid2";

type Options = {
  fingerprint?: string;
};

export default function createId(options: Options = {}) {
  return init({ fingerprint: options.fingerprint })();
}
